import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PhoneRegularDiagonalOut from './phone-regular-diagonal-out-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PhoneRegularDiagonalOut {...validProps} />;
}
SvgComponent.iconName = 'phoneRegularDiagonalOut';

export const PhoneRegularDiagonalOutIcon = svgIconWrapper(SvgComponent);
